import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import ls from 'localstorage-slim'
import CryptoJS from 'crypto-js'
import Store from './stores'
import NotFound from './views/NotFound.vue'

import Agreement from './components/Authentication/Agreement.vue'
import Login from './components/Authentication/Login.vue'
import ChangePassword from './components/Account/ChangePassword.vue'
import SuperAdmin from './views/SuperAdmin.vue'
import Admin from './views/Admin.vue'
import ServiceInfo from './components/Admin/ServiceInfo.vue'
import User from './components/Admin/UserList.vue'
import Code from './components/Admin/Code.vue'
import SubmitCategory from './components/Admin/SubmitCategory.vue'
import PidType from './components/Admin/PidType.vue'
import Payment from './components/Admin/Payment.vue'
import MyInfo from './components/Account/MyInfo.vue'

import Content from './views/Content.vue'
import Analytics from './views/Analytics.vue'
import Category from './views/Category.vue'
import PageList from './views/PageList.vue'
import PageItem from './views/PageItem.vue'
import Setting from './views/Setting.vue'
import MenuList from './views/MenuList.vue'
import MenuItem from './views/MenuItem.vue'
import ProductList from './views/ProductList.vue'
import ProductItem from './views/ProductItem.vue'
import ReservationList from './views/ReservationList.vue'
import ReservationItem from './views/ReservationItem.vue'
import Coupon from './views/Coupon.vue'
import Amenity from './views/Amenity.vue'
import Tv from './views/Tv.vue'
import ControlList from './views/ControlList.vue'
import ControlItem from './views/ControlItem.vue'
import LocalInfo from './views/LocalInfo.vue'
import LocalInfoCreate from './views/LocalInfoCreate.vue'
import FlightInfo from './views/FlightInfo.vue'
import Floating from './views/Floating.vue'
import SmartVoice from './views/SmartVoice'
import Thirdparty from './views/Thirdparty'
import Layerpopup from './views/Layerpopup'
import Features from './views/Features'
import GetAuth from './components/Authentication/GetAuth.vue'
import Talk from './views/Talk'
import Waitingcall from './views/Waitingcall'
import Package from './views/Package'
import Shop from './views/Shop'
import ShopLists from './components/Shop/ShopLists'
import ShopPage from './components/Shop/ShopPage'
import ShopItems from './components/Shop/ShopItems'
import ShopOptions from './components/Shop/ShopOptions'
import ShopPreset from './components/Shop/ShopPreset'
import ShopPdfLayout from './components/Shop/PdfLayout'

import CollectionList from './components/Collection/List'
import CollectionPage from './components/Collection/Page'
import CollectionSettings from './components/Collection/Settings'
import CollectionNav from './components/Collection/Navigation'
import CollectionItemList from './components/Collection/ItemList'
import MyCollection from './components/Collection/MyCollection'


ls.config.encrypt = true
ls.config.secret = 'istay-key-password'
ls.config.encrypter = (data, secret) => CryptoJS.AES.encrypt(JSON.stringify(data), secret).toString()
ls.config.decrypter = (data, secret) => {
  try {
    return JSON.parse(CryptoJS.AES.decrypt(data, secret).toString(CryptoJS.enc.Utf8))
  } catch (e) {
    // incorrect secret, return the encrypted data instead / or null
    return data // or return null;
  }
}

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      meta: { requiresAuth: true },
      redirect: {
        name: 'pageList',
        params: { paging: 1 }
      }
    },
    {
      path: '/',
      meta: { requiresAuth: true },
      redirect: {
        name: 'pageList',
        params: { paging: 1 }
      }
    },
    {
      path: '/shop',
      name: 'shop',
      component: Shop,
      meta: { requiresAuth: true },
      redirect: {
        name: 'shopList'
      },
      children: [
        {
          path: 'list',
          name: 'shopList',
          component: ShopLists,
        },
        {
          path: 'page/:id?/:categoryId?',
          name: 'shopPage',
          component: ShopPage,
          props: true
        },
        {
          path: 'pdfLayout/:id',
          name: 'shopPdfLayout',
          component: ShopPdfLayout,
          props: true
        },
        {
          path: 'option/:id?',
          name: 'shopOption',
          component: ShopOptions,
          props: true
        },
        {
          path: 'preset',
          name: 'shopPreset',
          component: ShopPreset
        }
      ]
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: Agreement,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/change_password/:code?',
      name: 'change_password',
      component: ChangePassword,
      props: true
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: Analytics,
      meta: { requiresAuth: true }
    },
    {
      path: '/category',
      name: 'category',
      component: Category,
      meta: { requiresAuth: true }
    },
    {
      path: '/floating',
      name: 'floating',
      component: Floating,
      meta: { requiresAuth: true }
    },
    {
      path: '/page',
      component: Content,
      meta: { requiresAuth: true },
      redirect: {
        name: 'pageList',
        params: { paging: 1 }
      },
      children: [
        {
          path: 'list/:paging',
          name: 'pageList',
          component: PageList,
          props: true
        },
        {
          path: 'item',
          name: 'pageNewItem',
          component: PageItem
        },
        {
          path: 'item/:id',
          name: 'pageItem',
          component: PageItem,
          props: true
        }
      ]
    },
    {
      path: '/menu',
      component: Content,
      meta: { requiresAuth: true },
      redirect: {
        name: 'menuList',
        params: { paging: 1 }
      },
      children: [
        {
          path: 'list/:paging',
          name: 'menuList',
          component: MenuList,
          props: true
        },
        {
          path: 'item',
          name: 'menuNewItem',
          component: MenuItem
        },
        {
          path: 'item/:id',
          name: 'menuItem',
          component: MenuItem,
          props: true
        }
      ]
    },
    {
      path: '/product',
      component: Content,
      meta: { requiresAuth: true },
      redirect: {
        name: 'productList',
        params: { paging: 1 }
      },
      children: [
        {
          path: 'list/:paging',
          name: 'productList',
          component: ProductList,
          props: true
        },
        {
          path: 'item',
          name: 'productNewItem',
          component: ProductItem
        },
        {
          path: 'item/:id',
          name: 'productItem',
          component: ProductItem,
          props: true
        }
      ]
    },
    {
      path: '/reservation',
      component: Content,
      meta: { requiresAuth: true },
      redirect: {
        name: 'reservationList',
        params: { paging: 1 }
      },
      children: [
        {
          path: 'list/:paging',
          name: 'reservationList',
          component: ReservationList,
          props: true
        },
        {
          path: 'item',
          name: 'reservationNewItem',
          component: ReservationItem
        },
        {
          path: 'item/:id',
          name: 'reservationItem',
          component: ReservationItem,
          props: true
        }
      ]
    },
    {
      path: '/collection',
      name: 'collection',
      component: CollectionList,
    },
    {
      path: '/collection/:pageId/:categoryId?',
      name: 'collectionPage',
      component: CollectionPage,
      props: true,
      // children: [
      //   {
      //     path: 'settings',
      //     name: 'collectionSettings',
      //     component: CollectionSettings,
      //     props: true
      //   },
      //   {
      //     path: 'nav',
      //     name: 'collectionNav',
      //     component: CollectionNav,
      //     props: true
      //   },
      //   {
      //     path: ':categoryId?',
      //     name: 'collectionItemList',
      //     component: CollectionItemList,
      //     props: true
      //   },
      //   {
      //     path: 'myCollection',
      //     name: 'myCollection',
      //     component: MyCollection,
      //     props: true
      //   },
      // ]
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: Coupon,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (userRole() === 'admin' || userRole() === 'manager') {
          next()
        } else {
          alert('Unauthorized.')
          next({
            name: 'pageList',
            params: { paging: 1 }
          })
        }
      }
    },
    {
      path: '/amenity',
      name: 'amenity',
      component: Amenity,
      meta: { requiresAuth: true }
    },
    {
      path: '/tv',
      name: 'tv',
      component: Tv,
      meta: { requiresAuth: true }
    },
    {
      path: '/control',
      name: 'control',
      component: ControlList,
      meta: { requiresAuth: true }
    },
    {
      path: '/control/item',
      name: 'controlNewItem',
      component: ControlItem,
      meta: { requiresAuth: true }
    },
    {
      path: '/control/item/:id/:subtype',
      name: 'controlItem',
      component: ControlItem,
      meta: { requiresAuth: true }
    },
    {
      path: '/localinfo',
      name: 'localinfo',
      component: LocalInfo,
      meta: { requiresAuth: true }
    },
    {
      path: '/localinfo/create',
      name: 'createLocalinfo',
      component: LocalInfoCreate,
      meta: { requiresAuth: true }
    },
    {
      path: '/flightinfo',
      name: 'flightinfo',
      component: FlightInfo,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (sitePlan() === 'premium') {
          next()
        } else {
          alert('Unauthorized.')
          next({
            name: 'pageList',
            params: { paging: 1 }
          })
        }
      }
    },
    {
      path: '/setting',
      name: 'setting',
      component: Setting,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (userRole() === 'admin') {
          next()
        } else {
          alert('Unauthorized.')
          next({
            name: 'pageList',
            params: { paging: 1 }
          })
        }
      }
    },
    {
      path: '/account',
      name: 'account',
      component: MyInfo,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (userRole() === 'admin') {
          if (to.params && to.name !== to.params.admin) {
            next({
              name: to.params.admin,
              params: to.params
            })
          } else {
            next()
          }
        } else {
          alert('Unauthorized.')
          next({
            name: 'pageList',
            params: { paging: 1 }
          })
        }
      },
      children: [
        {
          path: ':admin',
          name: 'userlist',
          component: User,
          props: true
        },
        {
          path: ':admin',
          name: 'serviceinfo',
          component: ServiceInfo,
          props: true
        },
        {
          path: ':admin',
          name: 'payment',
          component: Payment,
          props: true
        },
        {
          path: ':admin',
          name: 'codelist',
          component: Code,
          props: true
        },
        {
          path: ':admin',
          name: 'submitcategory',
          component: SubmitCategory,
          props: true
        },
        {
          path: ':admin',
          name: 'pidtype',
          component: PidType,
          props: true
        }
      ]
    },
    {
      path: '/smartvoice',
      name: 'smartvoice',
      component: Content,
      meta: { requiresAuth: true },
      redirect: {
        name: 'smartvoiceList'
      },
      children: [
        {
          path: ':groupId?',
          name: 'smartvoiceList',
          component: SmartVoice,
          props: true
        }
      ]
    },
    {
      path: '/thirdparty',
      name: 'thirdparty',
      component: Content,
      meta: { requiresAuth: true },
      redirect: {
        name: 'thirdpartyList',
        params: {
          id: 'facebookmessanger'
        }
      },
      children: [
        {
          path: ':id',
          name: 'thirdpartyList',
          component: Thirdparty,
          props: true
        },
        {
          path: ':id/auth/:code',
          name: 'thirdpartyAuth',
          component: Thirdparty,
          meta: {
            requiresAuth: true,
            authIds: [
              'instagramfeed' // 인증이 필요한 서드파티 array
            ]
          }
        }
      ]
    },
    {
      path: '/waitingcall/:spaceCode?',
      name: 'waitingcall',
      component: Waitingcall,
      meta: { requiresAuth: true },
      props: true
    },
    {
      path: '/package',
      name: 'package',
      component: Package,
      meta: { requiresAuth: true },
      props: true
    },
    {
      path: '/layerpopup',
      name: 'layerpopup',
      component: Layerpopup,
      meta: { requiresAuth: true }
    },
    {
      path: '/features',
      name: 'features',
      component: Features,
      meta: { requiresAuth: true }
    },
    {
      path: '/superadmin',
      name: 'superadmin',
      component: SuperAdmin,
      meta: { requiresAuth: true }
    },
    {
      path: '/getAuth',
      name: 'getAuth',
      component: GetAuth,
      meta: { requiresAuth: true }
    },
    {
      path: '/talk/:talk',
      name: 'talk',
      component: Talk,
      meta: { requiresAuth: true }
    }
  ]
})
export default router

const isLogin = () => {
  const lsKey = ls.get('istayKey')
  const isLogin = lsKey && lsKey.isLogin
  return isLogin
}
const userRole = () => {
  const lsKey = ls.get('istayKey')
  const role = lsKey && lsKey.userRole
  return role
}
const sitePlan = () => {
  const lsKey = ls.get('istayKey')
  const paln = lsKey && lsKey.sitePlan
  return paln
}

const getUrlParams = function () {
  const params = {}
  window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (_str, key, value) {
    params[key] = value
  })
  return params
}

const isRequestDev = () => {
  return getUrlParams().debug && getUrlParams().debug === '1'
}

const isLocal = window.location.origin.includes('localhost')

// router.push 오버라이드
const originalPush = router.push
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  });
};

// router.replace도 마찬가지로 덮어쓰기
const originalReplace = router.replace
router.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  });
};

if (isLogin() && !isRequestDev() && !isLocal) {
  axios.defaults.withCredentials = true
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 로그인 체크
    if (!isLogin() && to.name !== 'login') {
      next({
        path: '/login'
      })
      Store.dispatch('authentication/logout')
    } else {
      next()
    }
  } else {
    next()
  }
})
